import { useSelector } from 'react-redux';
import { RootState } from 'store';

const WelcomeHero: React.FC = () => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);

  return (
    <div className="text-text-primary space-y-5">
      <div className="mb-6">
        <img
          src={isDarkMode ? '/transcript-dark.png' : '/transcript.png'}
          alt="Welcome to Transcript Generator"
          className="max-h-[120px] md:max-h-[146px] h-full"
        />
      </div>
      <h1 className="text-2xl md:text-5xl font-medium text-text-primary lg:leading-[60px] md:max-w-[400px] mb-2">
        Welcome to Transcript Generator
      </h1>
      <p className="text-sm lg:text-xl font-normal text-text-primary md:w-[400px] mb-6 lg:mb-0">
        Transform your audio and video content into accurate, readable text with
        our easy-to-use transcript generator. Whether you&apos;re a student,
        professional, or content creator, streamline your workflow and save
        valuable time.
      </p>
    </div>
  );
};

export default WelcomeHero;
